<template>
    <div class="each-goods">
        <img :src="item.img"
            @error.once="__change__no__image"
            class="preview">
         <img :src="hotIconSrc" class="hot-icon" 
            alt="hot-icon"
            v-if="item.isRecommend == 1">
        <div class="detail">
            <div class="name"
                v-text="item.name"></div>
            <div class="price-wra">
                <span class="price">￥<span class="number"
                        v-text="item.price"></span></span>
            </div>
            <div class="comment-wra">
                <span class="rate">{{item.score}}分</span>
                <span class="comment">{{item.assess==0?'暂无评论':item.assess+'条评论'}}</span>
            </div>
        </div>
    </div>
   
</template>

<script>
export default {
    name: "ListOfWenChuang",
    // inheritAttrs: false,
    props: {
        item: Object
    },
    data() {
        return {
            hotIconSrc: ""
        };
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {
        this.hotIconSrc = API.ossUrl + "home/png/hot-icon.png";
    },
    destroyed() {},
    methods: {
        tagsSlice(tags) {
            return tags.length > 2 ? tags.slice(0, 2) : tags;
        }
    }
};
</script>


<style scoped lang="scss">
.each-goods {
    position: relative;
    overflow: hidden;
    margin-bottom: 0.64rem;
    display: flex;
    width: 100%;
    .hot-icon {
        width: 1.066667rem;
        height: 0.64rem;
        position: absolute;
        top: 0;
        left: 0;
    }
    &:nth-last-child(2) {
        border-bottom: 0;
    }
    .preview {
        width: 2.56rem;
        height: 2.56rem;
        display: block;
        border-radius: 0.266667rem;
    }
    .detail {
        margin-left: 0.32rem;
        background: $white;
        flex: auto;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .name {
            font-size: 0.4267rem;
            color: #343434;
            @include multiple-text-overflow(2);
            font-weight:bold;
            line-height:0.586667rem;
            overflow: hidden;
        }
        .tag-wra {
            display: flex;
            align-items: center;
            // margin: 0.1rem 0;
            .cou {
                margin-right: 0.16rem;
            }
        }
        .price-wra {
            display: flex;
            align-items: center;
            .price {
                font-size: 20px;
                color: #ff9200;
                .number {
                    font-weight: bold;
                    line-height: 0.746667rem;
                }
            }
        }
        .comment-wra {
            display: flex;
            align-items: center;
            .rate {
                color: $orange;
                position: relative;
                font-size: 0.32rem;
                padding-right: 0.133333rem;
                display: inline-block;
                &:before {
                    position: absolute;
                    top: 0;
                    right: 0;
                    height: 76%;
                    width: 1px;
                    content: "";
                    background: #b3b3b3;
                    bottom: 0;
                    margin: auto;
                }
            }
            .comment {
                color: #b3b3b3;
                font-size: 0.32rem;
                padding-left: 0.133333rem;
            }
        }
    }
}
</style>

